import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Vehicle } from 'app/models/vehicle.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { User } from 'app/models/user.model';


@Injectable({
  providedIn: 'root'
})
export class VehiclesService {

  options: {
    headers?: HttpHeaders | {[header: string]: string | string[]},
    observe?: 'body' | 'events' | 'response',
    params?: HttpParams|{[param: string]: string | string[]},
    reportProgress?: boolean,
    responseType?: 'arraybuffer'|'blob'|'json'|'text',
    withCredentials?: boolean,
  }

  apiUrl: string = `${environment.apiUrl}vehicle`;
  idEmpresa: number = 1;

  constructor(private client: HttpClient) { }

  getVehicles(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    return this.client.get<Vehicle[]>(this.apiUrl + `?enterpriseId=${enterprise.databaseId}`).toPromise();
  }

  getVehicle(id: number){
    // get one vehicle by Id
    // return this.client.get<Vehicle>(this.apiUrl)
  }

  saveVehicle(vehicle: Vehicle): Observable<Vehicle>{
    
    if(vehicle.id){
      // actualizar vehiculo
      console.log('actualizar este vehiculo: ',vehicle)
      return this.client.put<Vehicle>(this.apiUrl, vehicle).pipe(catchError(this.handleError));
    }else{
      // add vehicle
    return this.client.post<Vehicle>(this.apiUrl, vehicle).pipe(
      catchError(this.handleError)
    )
    }
  }
  inactiveVehicle(id: number){
    // inactive a vehicle by Id
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
